export default function ScrollPage({children}: {children: React.ReactNode})
{
    return (
        <div className={"py-6 px-4 sm:px-6 lg:px-8 h-full overflow-y-auto overflow-x-hidden 2xl:px-[10%] relative bg-slate-100"}>
            {children}
        </div>
    )
}